import { useState } from 'react';

const FancyTextGenerator = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');


    // Clear input fields
    const clearFields = () => {
      setText('');
      setResult('');
    };


  
  const bold = {
    'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲',
    'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶', 'j': '𝗷',
    'k': '𝗸', 'l': '𝗹', 'm': '𝗺', 'n': '𝗻', 'o': '𝗼',
    'p': '𝗽', 'q': '𝗾', 'r': '𝗿', 's': '𝘀', 't': '𝘁',
    'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 'y': '𝘆',
    'z': '𝘇', 'A': '𝗔', 'B': '𝗕', 'C': '𝗖', 'D': '𝗗',
    'E': '𝗘', 'F': '𝗙', 'G': '𝗚', 'H': '𝗛', 'I': '𝗜',
    'J': '𝗝', 'K': '𝗞', 'L': '𝗟', 'M': '𝗠', 'N': '𝗡',
    'O': '𝗢', 'P': '𝗣', 'Q': '𝗤', 'R': '𝗥', 'S': '𝗦',
    'T': '𝗧', 'U': '𝗨', 'V': '𝗩', 'W': '𝗪', 'X': '𝗫',
    'Y': '𝗬', 'Z': '𝗭'
  };

  const italic = {
    'a': '𝘢', 'b': '𝘣', 'c': '𝘤', 'd': '𝘥', 'e': '𝘦',
    'f': '𝘧', 'g': '𝘨', 'h': '𝘩', 'i': '𝘪', 'j': '𝘫',
    'k': '𝘬', 'l': '𝘭', 'm': '𝘮', 'n': '𝘯', 'o': '𝘰',
    'p': '𝘱', 'q': '𝘲', 'r': '𝘳', 's': '𝘴', 't': '𝘵',
    'u': '𝘶', 'v': '𝘷', 'w': '𝘸', 'x': '𝘹', 'y': '𝘺',
    'z': '𝘻', 'A': '𝘈', 'B': '𝘉', 'C': '𝘊', 'D': '𝘋',
    'E': '𝘌', 'F': '𝘍', 'G': '𝘎', 'H': '𝘏', 'I': '𝘐',
    'J': '𝘑', 'K': '𝘒', 'L': '𝘓', 'M': '𝘔', 'N': '𝘕',
    'O': '𝘖', 'P': '𝘗', 'Q': '𝘘', 'R': '𝘙', 'S': '𝘚',
    'T': '𝘛', 'U': '𝘜', 'V': '𝘝', 'W': '𝘞', 'X': '𝘟',
    'Y': '𝘠', 'Z': '𝘡'
  };

  const superscript = {
    'a': 'ᵃ', 'b': 'ᵇ', 'c': 'ᶜ', 'd': 'ᵈ', 'e': 'ᵉ',
    'f': 'ᶠ', 'g': 'ᵍ', 'h': 'ʰ', 'i': 'ⁱ', 'j': 'ʲ',
    'k': 'ᵏ', 'l': 'ˡ', 'm': 'ᵐ', 'n': 'ⁿ', 'o': 'ᵒ',
    'p': 'ᵖ', 'q': 'ᵠ', 'r': 'ʳ', 's': 'ˢ', 't': 'ᵗ',
    'u': 'ᵘ', 'v': 'ᵛ', 'w': 'ʷ', 'x': 'ˣ', 'y': 'ʸ',
    'z': 'ᶻ', 'A': 'ᴬ', 'B': 'ᴮ', 'C': 'ᶜ', 'D': 'ᴰ',
    'E': 'ᴱ', 'F': 'ᶰ', 'G': 'ᴳ', 'H': 'ʰ', 'I': 'ᵻ',
    'J': 'ᴶ', 'K': 'ᴷ', 'L': 'ᴸ', 'M': 'ᵐ', 'N': 'ᴺ',
    'O': 'ᴼ', 'P': 'ᴾ', 'Q': 'ᵠ', 'R': 'ᴿ', 'S': 'ˢ',
    'T': 'ᵀ', 'U': 'ᵁ', 'V': 'ⱽ', 'W': 'ᵂ', 'X': 'ˣ',
    'Y': 'ʸ', 'Z': 'ᶻ',
    '0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴',
    '5': '⁵', '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹',
    '+': '⁺', '-': '⁻', '=': '⁼', '(': '⁽', ')': '⁾'
    
};


const subscript = {
    'a': 'ₐ', 'b': 'ᵦ', 'c': 'c', 'd': 'ᵈ', 'e': 'ₑ',
    'f': 'f', 'g': 'ᵍ', 'h': 'ʰ', 'i': 'ᵢ', 'j': 'ʲ',
    'k': 'ₖ', 'l': 'ˡ', 'm': 'ᵐ', 'n': 'ₙ', 'o': 'ₒ',
    'p': 'ᵖ', 'q': 'q', 'r': 'ʳ', 's': 'ˢ', 't': 'ₜ',
    'u': 'ᵘ', 'v': 'ᵛ', 'w': 'ʷ', 'x': 'ˣ', 'y': 'ʸ',
    'z': 'ᶻ', 'A': 'ᴬ', 'B': 'ᴮ', 'C': 'ᶜ', 'D': 'ᴰ',
    'E': 'ᴱ', 'F': 'ᶰ', 'G': 'ᴳ', 'H': 'ʰ', 'I': 'ᵻ',
    'J': 'ᴶ', 'K': 'ᴷ', 'L': 'ᴸ', 'M': 'ᵐ', 'N': 'ᴺ',
    'O': 'ᴼ', 'P': 'ᴾ', 'Q': 'ᵠ', 'R': 'ᴿ', 'S': 'ˢ',
    'T': 'ᵀ', 'U': 'ᵁ', 'V': 'ⱽ', 'W': 'ᵂ', 'X': 'ˣ',
    'Y': 'ʸ', 'Z': 'ᶻ',
    '0': '₀', '1': '₁', '2': '₂', '3': '₃', '4': '₄',
    '5': '₅', '6': '₆', '7': '₇', '8': '₈', '9': '₉',
    '+': '₊', '-': '₋', '=': '₌', '(': '₍', ')': '₎'
};


const code = {
    'a': '𝖆', 'b': '𝖇', 'c': '𝖈', 'd': '𝖉', 'e': '𝖊',
    'f': '𝖋', 'g': '𝖌', 'h': '𝖍', 'i': '𝖎', 'j': '𝖏',
    'k': '𝖐', 'l': '𝖑', 'm': '𝖒', 'n': '𝖓', 'o': '𝖔',
    'p': '𝖕', 'q': '𝖖', 'r': '𝖗', 's': '𝖘', 't': '𝖙',
    'u': '𝖚', 'v': '𝖛', 'w': '𝖜', 'x': '𝖝', 'y': '𝖞',
    'z': '𝖟', 'A': '𝖠', 'B': '𝖡', 'C': '𝖢', 'D': '𝖣',
    'E': '𝖤', 'F': '𝖥', 'G': '𝖦', 'H': '𝖧', 'I': '𝖨',
    'J': '𝖩', 'K': '𝖪', 'L': '𝖫', 'M': '𝖬', 'N': '𝖭',
    'O': '𝖮', 'P': '𝖯', 'Q': '𝖰', 'R': '𝖱', 'S': '𝖲',
    'T': '𝖳', 'U': '𝖴', 'V': '𝖵', 'W': '𝖶', 'X': '𝖷',
    'Y': '𝖸', 'Z': '𝖹', '0': '𝟘', '1': '𝟙', '2': '𝟚',
    '3': '𝟛', '4': '𝟜', '5': '𝟝', '6': '𝟞', '7': '𝟟',
    '8': '𝟠', '9': '𝟡', '+': '𝟣', '-': '𝟪', '=': '𝟫',
    '(': '𝟭', ')': '𝟬', '{': '𝟮', '}': '𝟯', '[': '𝟰',
    ']': '𝟱', ';': '𝟲', ':': '𝟷', ',': '𝟸', '.': '𝟹',
    '!': '𝟶', '?': '𝟷', '&': '𝟸', '#': '𝟹', '@': '𝟺',
    '$': '𝟻', '%': '𝟼', '^': '𝟽', '*': '𝟾', '"': '𝟿',
    "'": '𝖀', '/': '𝖁', '\\': '𝖂', '|': '𝖃', '`': '𝖄'
  };
  

 
  const styles = [
    { name: 'Bold', style: (text) => transformText(text, bold) },
    { name: 'Italic', style: (text) => transformText(text, italic) },
    { name: 'Superscript', style: (text) => transformText(text, superscript) },
    { name: 'Subscript', style: (text) => transformText(text, subscript) },
    { name: 'Code', style: (text) => transformText(text, code) },
    { name: 'Strikethrough', style: (text) => text.split('').map(char => `̶${char}`).join('') }, // Strikethrough
    { name: 'Underline', style: (text) => text.split('').map(char => `̲${char}`).join('') }, // Underline
    { name: 'Upside Down', style: (text) => text.split('').map(c => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase()).join('') },
    { name: 'Reversed', style: (text) => text.split('').reverse().join('') },
    { name: 'Bubble Text', style: (text) => text.split('').map(char => `Ⓐ${char}`).join('') },
    { name: 'Heart Beat', style: (text) => text.split('').join('💓') },
    { name: 'Vogue', style: (text) => text.split('').map(char => `ᴀ${char}`).join('') },
    { name: 'Icy', style: (text) => text.split('').map(char => `❄${char}`).join('') },
    { name: 'Down Low', style: (text) => text.split('').map(char => `⬇${char}`).join('') },
    { name: 'Old English', style: (text) => text.split('').map(char => `ᴀ${char}`).join('') },
    { name: 'Double Struck', style: (text) => text.split('').map(char => `ᵓ8${char}`).join('') },
    { name: 'UFO', style: (text) => text.split('').map(char => `👽${char}`).join('') },
    { name: 'Ancient', style: (text) => text.split('').map(char => `⚱${char}`).join('') },
    { name: 'Cutout2', style: (text) => text.split('').map(char => `✂${char}`).join('') },
    { name: 'Squared Inverted', style: (text) => text.split('').map(char => `🄰${char}`).join('') },
    { name: 'Bubble Filled', style: (text) => text.split('').map(char => `ⓑ${char}`).join('') },
    { name: 'Squared', style: (text) => text.split('').map(char => `🅰${char}`).join('') },
  ];

 
  const transformText = (text, styleMap) => {
    return text.split('').map(char => styleMap[char] || char).join('');
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleStyleChange = (styleFunc) => {
    const transformedText = styleFunc(text);
    setResult(transformedText);
  };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label


  const handleCopyClick = () => {
    navigator.clipboard.writeText(result.replace("/</?[^>]+(>|$)/g", '')); 
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };


       // Function to calculate text statistics
       const calculateTextStats = (text) => {
        const totalCharacters = text.length;
        const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
        const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
        const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
        const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
    
        return {
          totalCharacters,
          totalCharactersWithoutSpace,
          totalWords,
          totalParagraphs,
          totalSentences,
        };
      };
    
    
        // Calculate stats dynamically based on current binary value
    const stats = calculateTextStats(text);

  return (
<div className="container mt-5 p-4 bg-white rounded shadow">
      
      <textarea
        className="w-full h-32 p-2 mb-4 border border-gray-400 rounded focus:outline-none focus:ring focus:border-blue-500"
        value={text}
        onChange={handleTextChange}
        placeholder="Enter your text here"
      />

      <div className="flex flex-wrap mb-4">
        {styles.map((style, index) => (
          <button
            key={index}
            className="mr-2 mb-2 py-2 px-4 bg-blue-500 hover:bg-blue-700 text-white font-bold rounded focus:outline-none focus:ring focus:border-blue-500"
            onClick={() => handleStyleChange(style.style)}
          >
            {style.name}
          </button>
        ))}
      </div>

      <div className="mb-4">
        <h2 className="text-2xl font-bold mb-2">Result: </h2>
        <div
          className="p-2 border border-gray-400 rounded break-all"
          dangerouslySetInnerHTML={{ __html: result }}
        />
      </div>

      <button className="btn btn-primary" onClick={handleCopyClick}>
  {copyButtonLabel}
  </button>

      <button className="btn btn-danger" onClick={clearFields}>
            Clear
          </button>

 
      <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>

    </div>
  );
};

export default FancyTextGenerator;
